import { useStore as baseUseStore } from 'vuex';
import { storeKey } from '@/store';
import type { CustomFieldListState } from '../types';

export const useStore = () => baseUseStore<{
  customField: CustomFieldListState;
}>(storeKey);
